import ProjectData from './ProjectData';
import SummaryData from './SummaryData';

export const projectDataStore = new ProjectData();
export const summaryDataStore = new SummaryData();


// WEBPACK FOOTER //
// ./src/stores/index.js